import {
  GET_BILLS_CATEGORIES_START,
  GET_BILLS_CATEGORIES_SUCCESS,
  GET_BILLS_CATEGORIES_ERROR,
} from 'constants/action-types/payBills/getBillsCategories';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_BILLS_CATEGORIES_START:
      return {
        ...state,
        getBillsCategories: {
          ...state.getBillsCategories,
          loading: true,
        },
      };
    case GET_BILLS_CATEGORIES_ERROR:
      return {
        ...state,
        getBillsCategories: {
          ...state.getBillsCategories,
          error: payload.error,
          loading: false,
        },
      };
    case GET_BILLS_CATEGORIES_SUCCESS:
      return {
        ...state,
        getBillsCategories: {
          ...state.getBillsCategories,
          ...payload,
          success: true,
          loading: false,
        },
      };
    default:
      return null;
  }
};
